import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Teleport as _Teleport, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9a299934")

_pushScopeId("data-v-9a299934")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mt-2 mb-3" }, " Pool creation requires 2 transactions: ", -1)
const _hoisted_2 = { class: "card-container" }
const _hoisted_3 = { class: "card-step text-green-500" }
const _hoisted_4 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ml-3 flex-1" }, [
  /*#__PURE__*/_createVNode("span", null, "Create Pool")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Create Pool ")
const _hoisted_7 = {
  key: 1,
  class: "ml-4 text-sm"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { class: "card-container mt-3" }
const _hoisted_10 = { class: "card-step text-green-500" }
const _hoisted_11 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "ml-3 flex-1" }, [
  /*#__PURE__*/_createVNode("span", null, "Join Pool")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Join Pool ")
const _hoisted_14 = {
  key: 1,
  class: "ml-4 text-sm"
}
const _hoisted_15 = {
  key: 0,
  class: "mt-6 mb-2"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "text-yellow-500" }, " We're still looking for the magic recipe that allows us to verify factory created contracts through the ftmscan API. Until then, please reach out to us on discord and someone from the team will manually verify your contract. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")
  const _component_BalBtn = _resolveComponent("BalBtn")
  const _component_BalCard = _resolveComponent("BalCard")
  const _component_PoolCreateConfirmModal = _resolveComponent("PoolCreateConfirmModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_BalCard, { class: "mt-4 mb-3" }, {
      default: _withId(() => [
        _hoisted_1,
        _createVNode("div", null, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.poolAddress !== '')
                ? (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 0,
                    name: "check",
                    class: "text-green-500"
                  }))
                : (_openBlock(), _createBlock("span", _hoisted_4, "1"))
            ]),
            _hoisted_5,
            (_ctx.poolAddress === '')
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createModalVisible = true)),
                  disabled: !_ctx.canCreatePool,
                  size: "sm",
                  loading: _ctx.creating,
                  "loading-label": "Creating..."
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createTextVNode(" Pool address: " + _toDisplayString(_ctx.poolAddress), 1),
                  _hoisted_8,
                  _createTextVNode("Pool id: " + _toDisplayString(_ctx.poolId), 1)
                ]))
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              (_ctx.joined)
                ? (_openBlock(), _createBlock(_component_BalIcon, {
                    key: 0,
                    name: "check",
                    class: "text-green-500"
                  }))
                : (_openBlock(), _createBlock("span", _hoisted_11, "2"))
            ]),
            _hoisted_12,
            (!_ctx.joined)
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  onClick: _ctx.joinPool,
                  disabled: _ctx.poolAddress === '',
                  size: "sm",
                  loading: _ctx.joining,
                  "loading-label": "Joining..."
                }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled", "loading"]))
              : (_openBlock(), _createBlock("div", _hoisted_14, " Joined "))
          ]),
          (_ctx.joined)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _hoisted_16
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      (_ctx.createModalVisible)
        ? (_openBlock(), _createBlock(_component_PoolCreateConfirmModal, {
            key: 0,
            onCreate: _ctx.createPool,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createModalVisible = false))
          }, null, 8, ["onCreate"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
})